import { render } from "./EditResident.vue?vue&type=template&id=bbecada0&scoped=true"
import script from "./EditResident.vue?vue&type=script&lang=js"
export * from "./EditResident.vue?vue&type=script&lang=js"

import "./EditResident.vue?vue&type=style&index=0&id=bbecada0&scoped=true&lang=css"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbecada0"]])

export default __exports__